import { render, staticRenderFns } from "./LinkExtensionModal.vue?vue&type=template&id=a94af7b2&scoped=true&"
import script from "./LinkExtensionModal.vue?vue&type=script&lang=js&"
export * from "./LinkExtensionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94af7b2",
  null
  
)

export default component.exports